import { createSetting } from '@shopex/finder'

export const tableSetting = (vm) => createSetting({
  search: [],
  columns: [
    { name: '券ID', key: 'card_id', minWidth: 150 },
    { name: '券名称', key: 'title', minWidth: 150 },
    { name: '券类型',
      key: 'card_type',
      minWidth: 120,
      formatter: v => vm.$options.filters['formatCardStr'].call(vm, v)
    },
    { name: '卡券有效期',
      key: 'time',
      minWidth: 300,
      render: (h, { row }) => {
        let takeEffect = ''
        let begin_time = row?.begin_date
        let end_time = row?.end_date
        if (row.date_type == 'DATE_TYPE_FIX_TERM') {
          const begin = row.begin_day_type == 0 ? '当' : row.begin_day_type
          takeEffect = `领取后${begin}天生效,${row.fixed_term}天有效`
        }

        if (takeEffect) {
          return(
            <div>
              <i class="el-icon-time"></i>
              {takeEffect}
              {row.end_date > 0 && <div>
                统一过期时间：{vm.$options.filters['datetime'].call(vm, row.end_date)}
                <span style="color: red">{
                    Date.parse(new Date()) > row.end_date * 1000
                      ? "已过期"
                      : ""
                  }</span>
              </div>}
            </div>
          )
        } else {
          return (
            <div>
              <i class="el-icon-time"></i>
              {vm.$options.filters['datetime'].call(vm, begin_time)}
              {end_time ? <span>~</span> : ''}
              {vm.$options.filters['datetime'].call(vm, end_time)}
              <span style="color: red">{
                  Date.parse(new Date()) > end_time * 1000
                    ? "已过期"
                    : ""
              }</span>
            </div>
          )
        }
      }
    },
  ],
  actions: [
    {
      name: '删除',
      type: 'button',
      buttonType: 'text',
      action: {
        handler: (rows) => {
          vm.handleDelete(rows)
        }
      }
    },
  ]
})
